module.exports = __webpack_public_path__ + "img/h-page4-20.cf994c55.png";